// extracted by mini-css-extract-plugin
export default {"alert":"OUZIfE"};